import { ButtonHTMLAttributes } from "react";
import NormalEditIcon from "../../assets/icons/NormalEditIcon";

type UpdatePriceProps = {
  children: number;
  className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

// price update edit button component
const UpdatePrice = ({
  children,
  className = "",
  ...rest
}: UpdatePriceProps) => (
  <div className="flex items-center gap-2.5">
    <span className={className}>{children}</span>
    <button
      className="p-0 m-0 border-transparent bg-transparent cursor-pointer"
      {...rest}
    >
      <NormalEditIcon />
    </button>
  </div>
);

export default UpdatePrice;
